<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">1. </span><a href="#/chapter001"><span class="toc-item-title-text cspan">For Want of a Hat</span></a></p>
<p class="toc-content toc-item-subtitle">Kate Dane</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">2. </span><a href="#/chapter002"><span class="toc-item-title-text cspan">Not on Our Watch</span></a></p>
<p class="toc-content toc-item-subtitle">Kevin Ikenberry</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">3. </span><a href="#/chapter003"><span class="toc-item-title-text cspan">Syracuse, the Eternal City</span></a></p>
<p class="toc-content toc-item-subtitle">Stephen K. Stein and Carolyn Ivy Stein</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">4. </span><a href="#/chapter004"><span class="toc-item-title-text cspan">The Doom of Egypt</span></a></p>
<p class="toc-content toc-item-subtitle">Julia V. Ashley</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">5. </span><a href="#/chapter005"><span class="toc-item-title-text cspan">Divine Calm</span></a></p>
<p class="toc-content toc-item-subtitle">Charles E. Gannon</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">6. </span><a href="#/chapter006"><span class="toc-item-title-text cspan">A Ruinous Rent</span></a></p>
<p class="toc-content toc-item-subtitle">L. A. Selby</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">7. </span><a href="#/chapter007"><span class="toc-item-title-text cspan">A Brother’s Oath</span></a></p>
<p class="toc-content toc-item-subtitle">L. Briar</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">8. </span><a href="#/chapter008"><span class="toc-item-title-text cspan">Xiào Shùn</span></a></p>
<p class="toc-content toc-item-subtitle">Lehua Parker</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">9. </span><a href="#/chapter009"><span class="toc-item-title-text cspan">Kutuzov at Gettysburg</span></a></p>
<p class="toc-content toc-item-subtitle">B. Daniel Blatt</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">10. </span><a href="#/chapter010"><span class="toc-item-title-text cspan">The Notorious Lawman Billy the Kid</span></a></p>
<p class="toc-content toc-item-subtitle">Edward J. Knight</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">11. </span><a href="#/chapter011"><span class="toc-item-title-text cspan">Out of Habit</span></a></p>
<p class="toc-content toc-item-subtitle">Julie Jones</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">12. </span><a href="#/chapter012"><span class="toc-item-title-text cspan">Aces High</span></a></p>
<p class="toc-content toc-item-subtitle">Jennifer M. Roberts</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">13. </span><a href="#/chapter013"><span class="toc-item-title-text cspan">Rufus and the Wizard of Wireless</span></a></p>
<p class="toc-content toc-item-subtitle">Stace Johnson</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">14. </span><a href="#/chapter014"><span class="toc-item-title-text cspan">G-Gals</span></a></p>
<p class="toc-content toc-item-subtitle">Kendrai Meeks</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">15. </span><a href="#/chapter015"><span class="toc-item-title-text cspan">Collateral Loss</span></a></p>
<p class="toc-content toc-item-subtitle">Fulvio Gatti</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">16. </span><a href="#/chapter016"><span class="toc-item-title-text cspan">Boulder Choke</span></a></p>
<p class="toc-content toc-item-subtitle">Carrie Callahan</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">17. </span><a href="#/chapter017"><span class="toc-item-title-text cspan">This Was Your Life (Play It Again, Sam)</span></a></p>
<p class="toc-content toc-item-subtitle">Mary Pletsch</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">18. </span><a href="#/chapter018"><span class="toc-item-title-text cspan">The Unnamed</span></a></p>
<p class="toc-content toc-item-subtitle">Gama Ray Martinez</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">19. </span><a href="#/chapter019"><span class="toc-item-title-text cspan">Three Times the Power, Four Times the Pain</span></a></p>
<p class="toc-content toc-item-subtitle">Akis Linardos</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">20. </span><a href="#/chapter020"><span class="toc-item-title-text cspan">Entropy Ranch</span></a></p>
<p class="toc-content toc-item-subtitle">Kevin J. Anderson</p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheeditor"><span class="toc-item-title-text cspan">About the Editor</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/ifyouliked"><span class="toc-item-title-text cspan">If You Liked …</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/otherwordfirepresstitleseditedbylisamangum"><span class="toc-item-title-text cspan">Other WordFire Press Titles Edited by Lisa Mangum</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2fc8fce5